module.exports = __webpack_public_path__ + "static/media/basketball-icon.c079aa42.webp";